import SiteLayout from "@/components/site/SiteLayout";
import { BRAND } from "@/config/brand";
import { Link } from "react-router-dom";
import { Shield, Users, Zap } from "lucide-react";
import useSeo from "@/lib/useSeo";

export default function About() {
  useSeo({
    title: "About GC Nexon — Human-Reviewed Gift Card Buyback",
    description: "GC Nexon is a transparent gift card buyback service. Learn who we are, why we started, and how we get you same-day payouts on every card.",
    path: "/about",
  });
  return (
    <SiteLayout>
      <section className="section-py container-x">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase mb-4">About us</span>
        <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight max-w-3xl">We built the buyback service we always wished existed.</h1>
        <p className="mt-6 text-lg text-muted-foreground max-w-2xl leading-relaxed">
          {BRAND.name} started when our founder tried to sell a $200 Best Buy card and got quoted 42%. Every competitor was slow, sketchy, or both. So we built something better — transparent rates, timely payouts, and real humans on support.
        </p>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {[
            { icon: Shield, t: "Same-day payout", d: "Most cards pay out the same day they're submitted. If verification takes longer, you'll get an email at every step." },
            { icon: Zap, t: "Fast payouts", d: "Most cards pay out same day. If verification takes longer, we email you at every step." },
            { icon: Users, t: "Real support", d: `Miles (AI) handles simple questions instantly. ${BRAND.managerName} and team handle the rest.` },
          ].map((v, i) => (
            <div key={i} className="card-soft">
              <div className="w-11 h-11 rounded-2xl bg-primary/10 text-primary flex items-center justify-center"><v.icon size={20} /></div>
              <h3 className="font-extrabold text-xl mt-4">{v.t}</h3>
              <p className="text-muted-foreground mt-2">{v.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 card-soft flex flex-col md:flex-row items-center gap-6">
          <div className="w-24 h-24 rounded-full bg-primary text-primary-foreground font-extrabold text-3xl flex items-center justify-center">JC</div>
          <div>
            <h3 className="font-extrabold text-xl">{BRAND.managerName}</h3>
            <p className="text-sm text-muted-foreground">Head of Operations</p>
            <p className="mt-2 max-w-xl">"If your submission ever feels stuck, my inbox is <a href={`mailto:${BRAND.email}`} className="text-primary underline">{BRAND.email}</a>. I read every escalation."</p>
          </div>
        </div>

        <div className="mt-14 text-center">
          <Link to="/submit" className="btn-pill">Sell your first card</Link>
        </div>
      </section>
    </SiteLayout>
  );
}
